import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import changeLogin from "../../store/Actions/LoginAction";
import { useHistory } from "react-router-dom";
import DashboardNavbar from "./DashboardNavbar";
import DashboardNavbarMobile from "./DashboardNavbarMobile";
import Sidebar from "./Sidebar";

function Dashboard(props) {
  const login = props.login;
  const history = useHistory();
  const [loading, setLoading] = useState(true);

  const logout = () => {
    localStorage.removeItem("userData");
    props.ChangeLogin(false);
    history.push("/");
  };

  useEffect(() => {
    const itemStr = localStorage.getItem("userData");
    if (!itemStr) {
      history.push("/login");
    }
    else{
      setLoading(false);
    }

    document.title = "VisaPro | Dashboard";
  }, []);

  return (
    <div>
      {loading ? (
        <div
          style={{
            height: "100vh",
            width: "100%",
            backgroundColor: "transparent",
          }}
        ></div>
      ) : (
        <div>
          <DashboardNavbar />
          <DashboardNavbarMobile />
          <Sidebar cmp={props.cmp} />
          {/* <button onClick={()=>{logout()}}>Logout</button> */}
        </div>
      )}
    </div>
  );
}

const mapDispatchToProp = (dispatch) => ({
  ChangeLogin: (login) => dispatch(changeLogin(login)),
});

export default connect("", mapDispatchToProp)(Dashboard);
